import React from "react";
import { useParams, Navigate, useLocation } from "react-router-dom";
import DynamicRedirect from "./DynamicRedirect";
import { redirectConfig } from "./redirectConfig";

const RedirectHandler: React.FC = () => {
  const location = useLocation();
  const fullPath = location.pathname;
  const params = useParams<Record<string, string>>();


  if (redirectConfig[fullPath]) {
    return <DynamicRedirect config={redirectConfig} pathKey={fullPath} />;
  }

  const dynamicPathKeys = Object.keys(redirectConfig).filter(key => key.includes(':'));
  
  for (const pathKey of dynamicPathKeys) {
    const regexPattern = pathKey.replace(/:[^/]+/g, '([^/]+)');
    const pathPattern = new RegExp('^' + regexPattern + '$');
    
    if (pathPattern.test(fullPath)) {
      const paramNames = pathKey.match(/:[^/]+/g)?.map(param => param.substring(1)) || [];
      
      const paramValues = fullPath.match(pathPattern)?.slice(1) || [];
      
      const pathParams: Record<string, string> = {};
      paramNames.forEach((name, index) => {
        pathParams[name] = paramValues[index];
      });

      return (
        <DynamicRedirect 
          config={redirectConfig} 
          pathKey={pathKey}
          pathParams={pathParams}
        />
      );
    }
  }
  
  return <Navigate to="/" replace />;
};

export default RedirectHandler;